export default __webpack_public_path__ + "static/media/programming.78b461cc.jpg";